import React, { Component } from "react";
import AmountList from "./amountList";
import HighestPayingBuyers from "./highestPayingBuyers";
import SubsetsList from "./subsetsList";
import Chart from "./chart";
import ecStat from "echarts-stat";
import GA from "lib/ga";

class Charts extends Component {
    constructor(props) {
        super(props);
        this.defaultSellersNumber = 23;
        this.state = {
            estimations: this.addProjectedData(this.props.trends.trends),
        };
        this.handleScroll = this.handleScroll.bind(this);
    }

    getProjectedValue(data) {
        const x = 24;
        let regression = ecStat.regression("linear", data);
        let y =
            regression.parameter.gradient * x + regression.parameter.intercept;
        return parseFloat(y.toFixed(2));
    }

    getUpdatedData(data) {
        let tempData = data.slice(0);
        let allData = data.map((item, i) => {
            return [i, item];
        });
        allData.shift();
        let y = this.getProjectedValue(allData);
        tempData.push(y);
        const newValue = tempData[0];
        const yearAgoValue = tempData[1];
        const projectedValue = tempData.pop();
        const inYearValue = tempData.pop();
        let chartData = [newValue, yearAgoValue, inYearValue, projectedValue];

        return chartData;
    }

    addProjectedData(estimations) {
        Object.keys(estimations).map((estimation) => {
            let data = this.getUpdatedData(estimations[estimation]);
            estimations[estimation] = data;
        });
        return estimations;
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
        this.graphPresentedArr = [true];
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll() {
        const chartNum = 5;
        for (let i = 1; i <= chartNum; i++) {
            if (!this.graphPresentedArr[i]) {
                let docViewTop = window.scrollY;
                let docViewBottom = docViewTop + window.innerHeight;
                let elem = document.querySelector(`#graph${i}`);
                let elemTop = elem.offsetTop;
                let elemBottom = elemTop + elem.clientHeight;

                if (elemBottom <= docViewBottom && elemTop >= docViewTop) {
                    let title = elem.children[0].innerText;
                    if (title.indexOf("\n") !== -1) {
                        title = title.substring(0, title.indexOf("\n"));
                    }
                    this.graphPresentedArr[i] = true;
                    if (i === chartNum) {
                        window.removeEventListener("scroll", this.handleScroll);
                    }
                }
            }
        }
    }

    // sort the object of items&prices by max price
    estimationsSortedByPrice(priceData) {
        if (!priceData) return;
        const sortByPrices = (pricesA, pricesB) =>
            Math.max(...pricesA[1]) - Math.max(...pricesB[1]);
        const arrToHashReduce = (acc, [itemType, prices]) => {
            acc[itemType] = prices;
            return acc;
        };
        return Object.entries(priceData)
            .sort(sortByPrices)
            .reduce(arrToHashReduce, {});
    }

    render() {
        const priceData = this.estimationsSortedByPrice(this.state.estimations);
        return (
            <div id="charts" className="graphs-section">
                <Chart
                    id="1"
                    name="priceOverTime"
                    priceData={priceData}
                    itemTypeName={this.props.trends.item_type_name}
                    estRange={this.props.trends.est_range}
                />
                <SubsetsList
                    id="2"
                    estimation={
                        (this.props.trends && this.props.trends.estimation) ||
                        null
                    }
                    priceData={priceData}
                    estRange={this.props.trends.est_range}
                    subsetValues={this.props.trends.subset_values}
                    brand={
                        (this.props.trends && this.props.trends.brand) || null
                    }
                />
                {/*<Chart id="3" name="similarValuables" itemValue={this.props.trends && this.props.trends.estimation || null} otherItemsValue={this.props.trends && this.props.trends.similar_items_value || null} sellerNumber={this.props.trends && this.props.trends.similar_sellers || this.defaultSellersNumber}/>*/}
                {/*<HighestPayingBuyers id="4" keyword={this.props.trends && this.props.trends.keyword || null}/>*/}
                <Chart
                    id="5"
                    name="gradingCertificates"
                    subTitle={true}
                    carat={
                        (this.props.trends && this.props.trends.size) || null
                    }
                />
                <AmountList itemId={this.props.itemId} />
            </div>
        );
    }
}

export default Charts;
